import { LoadState } from "../../constants/enums";


export interface ICommAutoCertificateofInsuranceState {
  certificateOfInsuranceList: ICommAutoCertificateofInsurance[];
  totalRecords: number;
  loading: LoadState;
}

export interface ICommAutoCertificateofInsurance {
  incremental_number: number;
  task_code: string;
  policy_number: string;
  customer_name: string;
  customer_code: string;
  policy_form_type: string;
  create_ts: string | null;
  created_by_name: string;
  status: string;
}

export const initialCommAutoCertificateofInsuranceState: ICommAutoCertificateofInsuranceState =
  {
    certificateOfInsuranceList: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
  };
